export const FrontendFr = {
  "options": "options",
  "Instructions de l'ONMDM": "Instructions de l'ONMDM",

  "Nos Services": "Nos Services",

  "À l'ONMDM, nous nous efforçons de fournir des services exceptionnels dans le domaine dentaire, en travaillant sans relâche pour améliorer la santé bucco-dentaire des Mauritaniens.": "À l'ONMDM, nous nous efforçons de fournir des services exceptionnels dans le domaine dentaire, en travaillant sans relâche pour améliorer la santé bucco-dentaire des Mauritaniens.",
  "Notre équipe est composée de professionnels hautement qualifiés, engagés à faire progresser les soins dentaires et les services grâce à des pratiques innovantes et des technologies de pointe.": "Notre équipe est composée de professionnels hautement qualifiés, engagés à faire progresser les soins dentaires et les services grâce à des pratiques innovantes et des technologies de pointe.",
  "En savoir plus": "En savoir plus",

  "Nos Partenaires": "Nos Partenaires",

  "Textes juridiques et réglementaires": "Textes juridiques et réglementaires",
  "L'Ordre National des Médecins Dentaires de Mauritanie rappelle à tous les praticiens que l'exercice de la profession est soumis aux règles déontologiques et réglementaires en vigueur.": "L'Ordre National des Médecins Dentaires de Mauritanie rappelle à tous les praticiens que l'exercice de la profession est soumis aux règles déontologiques et réglementaires en vigueur.",
  "Les obligations des médecins dentaires incluent notamment :": "Les obligations des médecins dentaires incluent notamment :",
  "Le respect du secret professionnel et des droits des patients": "Le respect du secret professionnel et des droits des patients",
  "L'application des normes d'hygiène et de sécurité sanitaire": "L'application des normes d'hygiène et de sécurité sanitaire",
  "L'interdiction de toute publicité ou promotion contraire à l'éthique": "L'interdiction de toute publicité ou promotion contraire à l'éthique",
  "La mise à jour régulière des connaissances médicales et techniques": "La mise à jour régulière des connaissances médicales et techniques",

  "ONMDM": "ONMDM",
  "L'Ordre National des Médecins Dentaires de Mauritanie (ONMDM) est une organisation professionnelle représentant les médecins dentaires en Mauritanie. Nous travaillons pour améliorer la qualité des soins dentaires et promouvoir la santé bucco-dentaire dans tout le pays.": "L'Ordre National des Médecins Dentaires de Mauritanie (ONMDM) est une organisation professionnelle représentant les médecins dentaires en Mauritanie. Nous travaillons pour améliorer la qualité des soins dentaires et promouvoir la santé bucco-dentaire dans tout le pays.",
  "Développé par Mohamed Salem Ould Lekbar": "Développé par Mohamed Salem Ould Lekbar",
  "Téléphone:": "Téléphone:",
  "Contactez-nous": "Contactez-nous",
  "Adresse:": "Adresse:",
  "Route de Nouadhibou, Nouakchott, Mauritanie": "Route de Nouadhibou, Nouakchott, Mauritanie",
  "Email:": "Email:",
  "Liens Utiles": "Liens Utiles",
  "À propos de l'ONMDM": "À propos de l'ONMDM",
  "Adhésion": "Adhésion",
  "Actualités": "Actualités",
  "Suivez-Nous": "Suivez-Nous",
  "ONMDM. Tous droits réservés.": "ONMDM. Tous droits réservés.",

  "Textes Juridiques et Réglementaires": "Textes Juridiques et Réglementaires",
  "Déposez Votre Plainte": "Déposez Votre Plainte",

  "Les Actualités de l'ONMDM": "Les Actualités de l'ONMDM",
  "Déposez votre plainte": "Déposez votre plainte",

  "Nom du patient": "Nom du patient",
  "Matricule": "Matricule",
  "Donnez votre matricule": "Donnez votre matricule",
  "Donnez votre numéro de téléphone": "Donnez votre numéro de téléphone",
  "Nom du Cabinet": "Nom du Cabinet",
  "Docteur": "Docteur",
  "Nom du Docteur": "Nom du Docteur",
  "Écrivez votre plainte contre ce docteur": "Écrivez votre plainte contre ce docteur",
  "Devis": "Devis",
  "Plainte" : "Plainte",

  "Page d'accueil": "Page d'accueil",
  "Chercher....": "Chercher....",

  "Développé par Mohamed Salem Ould kbar": "Développé par Mohamed Salem Ould kbar",

};
